import React, { FC } from 'react';
import {
  ACCESS_UNTIL,
  EMAIL_DOMAIN,
  ENTER_LIST_ID,
  ENTER_NAME,
  LOGO_URL,
  NAME,
  REGISTRATION_LINK,
  SENDY_LIST_ID
} from '../../utils/constants/labels';
import { DatePicker, Form, Input } from 'antd';
import { FormProps } from 'antd/lib/form';
import EditableTagGroup from '../common/inputs/EditableTagGroup';

type Props = FormProps & {
  value?: any;
};

const initialValues = { name: '', accessUntil: null, sendyListId: null };

const CreateOrganizationForm: FC<Props> = props => (
  <Form {...props} initialValues={props.value || initialValues}>
    <Form.Item name="name" label={NAME} rules={[{ required: true }]}>
      <Input placeholder={ENTER_NAME} />
    </Form.Item>
    <Form.Item name="accessUntil" label={ACCESS_UNTIL} rules={[{ required: true }]}>
      <DatePicker style={{ width: '100%' }} />
    </Form.Item>
    <Form.Item name="sendyListId" label={SENDY_LIST_ID}>
      <Input placeholder={ENTER_LIST_ID} />
    </Form.Item>
    <Form.Item name="registrationLink" label={REGISTRATION_LINK} rules={[{ required: true }]}>
      <Input placeholder={'app.shovelapp.io/-/signup/<reg-link>'} />
    </Form.Item>
    <Form.Item name="emailDomainName" label={EMAIL_DOMAIN}>
      <EditableTagGroup addLabel={'Add domain name'} />
    </Form.Item>
    <Form.Item name="logoUrl" label={LOGO_URL}>
      <Input />
    </Form.Item>
  </Form>
);

export default CreateOrganizationForm;
